import { Component, OnInit, Input } from '@angular/core';
import { ModalHelper } from '../../components/modal/modal.helper';
import { DataService } from '../../services/data.service';
import { UtilsService } from '../../services/utils.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {

  @Input() withoutTurn: boolean = false;
  public redirectForm: object = {};
  public cclient: string = "";
  public nameClient: string = "";
  public queues: any = [];
  public atypes: any = [];
  public atypesAll: any = [];
  public error: boolean = false;

  public actualFormType: string = "queue";

  private destroy$ = new Subject();

  constructor(private _modal: ModalHelper,
    private _utils: UtilsService,
    private _blogic: BusinesLogicService,
    public _data: DataService) { }

  ngOnInit() {
    if (this._data.configuration['useOnlyDeskRedirection']) {
      this.actualFormType = "desk";
    } else {
      this.actualFormType = "queue";
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /* Open redirect modal */
  public openRedirectModal(): void {
    if (this._data.selectedTurn == null) {
      this.cclient = this._data.turn["clientid"];
      this.nameClient = this._data.turn["clientname"];
      this.redirectForm['comment'] = this._utils.convertToPlainText(this._data.turn["rdcomment"]);
    } else {
      this.cclient = this._data.selectedTurn["clientid"];
      this.nameClient = this._data.selectedTurn["clientname"];
      this.redirectForm['comment'] = this._utils.convertToPlainText(this._data.selectedTurn["rdcomment"]);
    }
    this._blogic.getOnlineList();
    this._getQueueList();
  }

  /* Redirect action */
  public redirect(): void {
    var params: object;

    if (this._data.configuration["activeSupervisor"]
      && this._data.selectedTurn != null) {

      if (!this.withoutTurn) {
        params = {
          desk_id: this._data.selectedTurn["desk"],
          turn_id: this._data.selectedTurn["id"],
          fromqueue: this._data.selectedTurn["queue_id"],
          toqueue: parseInt(this.redirectForm["queue"]),
          rdcomment: this.redirectForm["comment"],
          position: this.redirectForm["mode"],
          kind_id: this.redirectForm["atype"],
          deskuser: this._data.session["username"],
          deskoperator: this._data.session["operator"]
        };
      } else {
        params = {
          desk_id: null,
          turn_id: this._data.selectedTurn["id"],
          fromqueue: this._data.selectedTurn["queue_id"],
          toqueue: parseInt(this.redirectForm["queue"]),
          rdcomment: this.redirectForm["comment"],
          position: this.redirectForm["mode"],
          kind_id: this.redirectForm["atype"],
          deskuser: this._data.session["username"],
          deskoperator: this._data.session["operator"]
        };
      }
    } else {
      params = {
        desk_id: this._data.session["desk"],
        turn_id: this._data.turn["id"],
        fromqueue: this._data.turn["queue_id"],
        toqueue: this.redirectForm["queue"],
        rdcomment: this.redirectForm["comment"],
        position: this.redirectForm["mode"],
        kind_id: this.redirectForm["atype"],
        deskuser: this._data.session["username"],
        deskoperator: this._data.session["operator"]
      };
    }

    this._changeInfo(params);
  }

  private _doMove(params): void {

    if (!this._data.configuration["redirectFirstAndLastMode"])
      params["position"] = "S";

    this._blogic.moveTurn(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this._data.actionContainer = 0;
          this._modal.hide("redirectModal");
          this._data.turn = null;
          this._data.selectedTurn = null;
        }
      );
  }

  private _changeInfo(moveParams): void {
    var params: object;
    if (this._data.configuration["activeSupervisor"]
      && this._data.selectedTurn != null) {
      if (!this.withoutTurn) {
        params = {
          desk_id: this._data.session["desk"],
          turn_id: this._data.selectedTurn["id"],
          queue_id: this._data.selectedTurn["queue_id"],
          prekind: this._data.selectedTurn["prekind_id"],
          task: this._data.selectedTurn["task"],
          clientid: this.cclient,
          clientname: this.nameClient,
          /*planhour: this._data.selectedTurn["planhour"],*/
          plandate: this._data.selectedTurn["plandate"]
        }
      } else {
        params = {
          desk_id: null,
          turn_id: this._data.selectedTurn["id"],
          queue_id: this._data.selectedTurn["queue_id"],
          prekind: this._data.selectedTurn["prekind_id"],
          task: this._data.selectedTurn["task"],
          clientid: this.cclient,
          clientname: this.nameClient,
          /*planhour: this._data.selectedTurn["planhour"],*/
          plandate: this._data.selectedTurn["plandate"]
        }
      }
    } else {
      params = {
        desk_id: this._data.session["desk"],
        turn_id: this._data.turn["id"],
        queue_id: this._data.turn["queue_id"],
        prekind: this._data.turn["prekind_id"],
        task: this._data.turn["task"],
        clientid: this.cclient,
        clientname: this.nameClient,
        /*planhour: this._data.turn["planhour"]*/
        plandate: this._data.turn["plandate"]
      };
    }

    this._blogic.setTicketInfo(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this._doMove(moveParams);
        }
      );
  }

  /* Parse queue list using the desk id as key of array */
  private _parseQueues(queues: any): any {
    var parseArray: any = queues;
    var filterArray: any[] = [];
    if (this._data.session["redirectorder"].length != 0) {
      var availableQueues: any[] = this._data.session["redirectorder"].split(',');
      for (let i = 0; i < parseArray.length; i++) {
        let index = availableQueues.indexOf(parseArray[i].id.toString());
        if (index != -1 || parseArray[i].qdesk_id != null) {
          filterArray[i] = parseArray[i];
        }
      }
      this.queues = this.cleanArray(filterArray);
    } else {
      this.queues = parseArray;
    }

    //this.atypesAll = this._parseAtypes();

    if (this.queues.length == 1) {
      this.redirectForm["queue"] = this.queues[0].id;
      this.changeQueue();
    }

    //this.changeQueue();

    if (this.atypes.length == 1) {
      this.redirectForm["atype"] = this.atypes[0].id;
    }

    this.redirectForm["mode"] = "S";
    this._modal.show("redirectModal");


  }

  /* Clean a Array deleting the empty slots */
  private cleanArray(actual): any {
    var newArray = new Array();
    for (var i = 0; i < actual.length; i++) {
      if (actual[i]) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }

  public getActualQueues(): any {

    let queues = [];
    if (this.actualFormType == 'queue') {
      this.queues.forEach(e => {
        if (e.qdesk_id == null)
          queues.push(e);
      });
    }

    if (this.actualFormType == 'desk') {
      this.queues.forEach(e => {
        if (e["qdeskactive"])
          queues.push(e);
      });

      queues = queues.sort(function (a, b) {
        return a.qdesk_id - b.qdesk_id;
      });
    }

    return queues;
  }

  /* Get queue list */
  private _getQueueList(): void {
    let params: object = {
      filter: "queue?ignorehidden=true"
    }
    this._blogic.getPlanList(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          let queues: any[] = response;
          this._parseQueues(queues);
        }
      );
  }

  changeQueue() {
    let queue = this.queues.find(x => x.id.toString() === this.redirectForm['queue'].toString());
    let queueAtypes = queue.qkinds;
    this.redirectForm['qdesk_id'] = queue.qdesk_id;

    this._blogic.kindListOffice()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          let parseArray: any[] = response;
          let filterArray: any[] = [];
          let atypes: any[] = [];
          if (this._data.session["redirectkind"].length != 0) {
            let availableAtypes: any[] = this._data.session["redirectkind"].split(',');
            for (let i = 0; i < parseArray.length; i++) {
              let index = availableAtypes.indexOf(parseArray[i].id.toString());
              if (index != -1) {
                filterArray[index] = parseArray[i];
              }
            }
            atypes = this.cleanArray(filterArray);

          }

          this.atypes = atypes.filter(e => queueAtypes.indexOf(e.id) !== -1);

          if (this.atypes.length == 1) {
            this.redirectForm['atype'] = this.atypes[0].id;
          }
        }
      );
  }

}
